import * as core from '../../../../../../../core'
import * as sr from '../sr'

export const RESOURCE = {
  payload: {
    alias: 'conditions',
    appAlias: sr.RESOURCE.payload.alias,
    description: 'Conditions',
    display: {
      isMain: true,
      position: 4,
    },
    name: 'Conditions',
    page: { alias: 'sr:conditions' },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
